<script setup>
import { computed } from 'vue';
import { format, isPast, isToday } from 'date-fns';

const props = defineProps({
  card: { type: Object, required: true },
});

const dueAt = computed(() => new Date(props.card.due_at));

const toneClass = computed(() => {
  if (props.card.status !== 'open') return 'text-n-slate-10';
  if (isPast(dueAt.value)) return 'text-n-ruby-11 bg-n-ruby-3';
  if (isToday(dueAt.value)) return 'text-n-amber-11 bg-n-amber-3';
  return 'text-n-slate-11';
});
</script>

<template>
  <span
    v-if="card.due_at"
    class="inline-flex items-center gap-1 px-1.5 h-5 text-xs rounded whitespace-nowrap"
    :class="toneClass"
    data-testid="card-due-at"
  >
    <span class="flex-shrink-0 i-lucide-clock size-3" />
    {{ format(dueAt, 'dd/MM HH:mm') }}
  </span>
</template>
